import { ConstractStudentDetails, ServiceConcept } from "../../service-concept/interfaces/serviceConcept";

export class ContractData {
  contractId: number;
  description: string;
  regularPrice: number;
  unusualPercentage: number;
  unusualPercentageDiscontinuous: number;
  percentCustody: number;
  percentCustodyEnte: number;
  isContractForStudents: boolean | 'indeterminate';
  invoiceAnnotation: string;
  no24hRestriction: boolean;
  offeredPriceDifference: number;
  groupFixed: boolean;
  includedTax: boolean;
  exerciseId: number;
  accountId: string;
  descriptionConcept: string;
  ammountUnity: boolean;
}

export class ContractDataRequest {
  contractId: number;
  description: string;
  regularPrice: number;
  unusualPercentage: number;
  unusualPercentageDiscontinuous: number;
  percentCustody: number;
  percentCustodyEnte: number;
  isContractForStudents: boolean | 'indeterminate';
  invoiceAnnotation: string;
  no24hRestriction: boolean;
  offeredPriceDifference: number;
  groupFixed: boolean;
  includedTax: boolean;
  exerciseId: number;
  groupedConcept: GroupedConcept;
}

export class ContractAddRequest {
  description: string;
  regularPrice: number;
  unusualPercentage: number;
  unusualPercentageDiscontinuous: number;
  percentCustody: number;
  percentCustodyEnte: number;
  isContractForStudents: boolean | 'indeterminate';
  invoiceAnnotation: string;
  no24hRestriction: boolean;
  offeredPriceDifference: number;
  groupFixed: boolean;
  includedTax: boolean;
  exerciseId: number;
  groupedConcept: GroupedConcept;
}

export class GroupedConcept {
  accountId: number;
  description: string;
  amountUnity: boolean;
}

export class ContractForm {
  contractId: number;
  description: string;
  regularPrice: number;
  unusualPercentage: number;
  unusualPercentageDiscontinuous: number;
  percentCustody: number;
  percentCustodyEnte: number;
  isContractForStudents: boolean | 'indeterminate';
  invoiceAnnotation: string;
  no24hRestriction: boolean;
  offeredPriceDifference: number;
  groupFixed: boolean;
  includedTax: boolean;
  exerciseId: number;
  accountId: string;
  descriptionConcept: string;
  ammountUnity: boolean;
  serviceConcepts: ServiceConcept[];
  contractDetails: ConstractStudentDetails[];

}
